import { Linkedin } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#0B1120] text-slate-300 pt-16 pb-8 overflow-hidden"
        >
            <div className="absolute inset-0 grid-bg opacity-30" aria-hidden />
            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-2.5">
                            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500 to-teal-400 text-slate-950 font-display font-extrabold">
                                T
                            </span>
                            <div className="flex flex-col leading-none">
                                <span className="font-display font-bold text-white text-lg tracking-tight">
                                    TecSuite
                                </span>
                                <span className="text-[10.5px] uppercase tracking-[0.18em] text-slate-500 mt-0.5">
                                    by Tecnologie S.r.l.
                                </span>
                            </div>
                        </div>
                        <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-md">
                            TecSuite è un prodotto software sviluppato da Tecnologie S.r.l. per la gestione operativa di
                            aziende IT, MSP e system integrator.
                        </p>
                    </div>

                    <div className="lg:col-span-4">
                        <p className="text-xs font-bold uppercase tracking-widest text-slate-500">Sede</p>
                        <address className="mt-3 not-italic text-sm text-slate-300 leading-relaxed">
                            Tecnologie S.r.l.<br />
                            Viale dell&apos;Industria, 11 — 37023 Grezzana (VR)<br />
                            Telefono: <a href="tel:+390454770241" className="hover:text-cyan-300">045 4770241</a><br />
                            Email:{" "}
                            <a href="mailto:info@tecsuite.it" className="hover:text-cyan-300">
                                info@tecsuite.it
                            </a>
                        </address>
                    </div>

                    <div className="lg:col-span-3">
                        <p className="text-xs font-bold uppercase tracking-widest text-slate-500">Link</p>
                        <ul className="mt-3 space-y-2 text-sm">
                            <li>
                                <a href="/privacy" data-testid="footer-privacy" className="text-slate-300 hover:text-cyan-300">
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a href="/cookie" data-testid="footer-cookie" className="text-slate-300 hover:text-cyan-300">
                                    Cookie Policy
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.tecnologieverona.it"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    data-testid="footer-tecnologie"
                                    className="text-slate-300 hover:text-cyan-300"
                                >
                                    Tecnologie S.r.l.
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.linkedin.com/"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    data-testid="footer-linkedin"
                                    className="inline-flex items-center gap-1.5 text-slate-300 hover:text-cyan-300"
                                >
                                    <Linkedin className="w-3.5 h-3.5" /> LinkedIn
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <p className="text-xs text-slate-500">
                        © {new Date().getFullYear()} Tecnologie S.r.l. — TecSuite. Tutti i diritti riservati.
                    </p>
                    <p className="text-xs text-slate-500">
                        Progettato per supportare processi organizzati e tracciabili.
                    </p>
                </div>
            </div>
        </footer>
    );
}
